import { css } from '@emotion/react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useEffect, useState } from 'react';

import { useSDK } from '../../../../../app';
import { styled } from '../../../../../styled';
import type { Theme } from '../../../../../theme/interface/detailed';
import { onAttachmentLoad } from '../hooks/useOnAttachmentLoad';
import { UnsentAttachmentPreview } from './attachmentPreview';

const styles = css`
	display: flex;
	flex-direction: column;
`;

const Component = observer(
	({ className = '' }: { className?: string; attachmentLoadHandler?: onAttachmentLoad }): ReactElement | null => {
		const [files, setFile] = useState<File[]>();
		const { attachmentsStore } = useSDK();

		useEffect(() => {
			const attachments = attachmentsStore.unsentAttachments;
			setFile(Array.from(attachments));
		}, [attachmentsStore.unsentAttachments, attachmentsStore.unsentAttachments.size]);

		if (!files || !attachmentsStore.unsentAttachments.size) {
			return null;
		}

		return (
			<div className={className}>
				{files.map((file, i) => (
					<UnsentAttachmentPreview key={i} file={file} />
				))}
			</div>
		);
	}
);

export const AttachmentsPreviewList = styled(Component)(
	({ theme, isPrechat = false }: { theme: Theme; isPrechat?: boolean }) => {
		const { borderTop, padding } = theme?.chat.attachments.attachmentsPreviewContainer;
		return css`
			border-top: ${isPrechat ? 'initial' : borderTop};
			padding: ${padding} ${styles};
		`;
	}
);
